import { useEffect, useState } from "react";
import { AdminService } from "../../../Services/Admin.service";
import { DonorService } from "../../../Services/Donor.Service";
import { Table, Dropdown, DropdownButton, Pagination } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";

import navdots from "../../../Assets/images/navdots.svg";
import Toaster from "../../../Components/Toaster";
import { Link } from "react-router-dom";


import TablePagination from "../../../Components/AdministrativeSettings/TablePagination";
import SearchInput from "../../../Components/AdministrativeSettings/SearchInput";
import AdminStatusDropdown from "../../../Components/AdministrativeSettings/AdminStatusDropdown";
import DonorTableRow from "../../../Components/AdministrativeSettings/DonorManagement/DonorTableRow";
import BiologicalSexDropdown from "../../../Components/AdministrativeSettings/BiologicalSexDropdown";
import SampleTypeDropdown from "../../../Components/AdministrativeSettings/SampleTypeDropdown";
import NumberOfDonationSort from "../../../Components/AdministrativeSettings/NumberOfDonartionSort";
import NoListDataAvailable from "../../../Components/NoListDataAvailable";
import LoadingComponent from "../../../Components/LoadingComponent";
import Loader from "../../../Components/Loader";
import { useMediaQuery } from "react-responsive";
import { SampleRequestService } from "../../../Services/SampleRequest.Service";
import PaymentTypeDropdown from "../../../Components/AdministrativeSettings/PaymentTypeDropdown";

function DonorListTable(props) {
    const [loading, setLoading] = useState(true);

    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');

    const [totalDonors, setTotalDonor] = useState(0);
    const [DonorList, setDonorList] = useState([]);
    const [statuses, setStatuses] = useState([]);
    const [samples, setSamples] = useState([]);
    const [genders, setGenders] = useState([]);
    const [payments, setPayments] = useState([]);
    //   const [roles, setRoles] = useState([]);
    const [selectedStatuses, setSelectedStatuses] = useState([]);
    const [selectedGenders, setSelectedGenders] = useState([]);
    const [selectedPayments, setSelectedPayment] = useState([]);
    const [selectedSamples, setSelectedSamples] = useState([]);
    //   const [selectedRoles, setSelectedRoles] = useState([]);

    const [donationSortDirection, setDonationSortDirection] = useState(null);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [pagination, setPagination] = useState({ page: 1, limit: 10, offset: 0 });

    const [searchId, setSearchId] = useState("");
    const [isSearchIdInputVisible, setSearchIdInputVisible] = useState(false);

    const [searchName, setSearchName] = useState("");
    const [isSearchInputVisible, setSearchInputVisible] = useState(false);

    //   const [searchEmail, setSearchEmail] = useState("");
    //   const [isSearchEmailVisible, setSearchEmailVisible] = useState(false);
    //   const [searchPhone, setSearchPhone] = useState("");
    //   const [isSearchPhoneVisible, setSearchPhoneVisible] = useState(false);
    //   const [searchId, setSearchId] = useState("");
    //   const [isSearchIdVisible, setSearchIdVisible] = useState(false);

    const { isClearFilter } = props;
    const { onFilterCountChange } = props;
    const { exportCsv } = props;

    
    useEffect(() => {
        if (isClearFilter) {
            setSelectedStatuses([]);
            setSelectedGenders([]);
            setSelectedPayment([]);
            setSelectedSamples([]);
            setSearchName("");
            setSearchId("");
            setSearchInputVisible(false);
            setSearchIdInputVisible(false);
            onFilterCountChange(0);
            setDonationSortDirection(null);
        }
    }, [isClearFilter]);

       // Calculate and update the filter count
  useEffect(() => {
    const count = [
      selectedStatuses.length > 0 ? 1 : 0, 
      selectedGenders.length > 0 ? 1 : 0, 
      selectedPayments.length > 0 ? 1 : 0, 
      selectedSamples.length > 0 ? 1 : 0, 
      donationSortDirection !== null ? 1 : 0, 
      searchName ? 1 : 0, 
      searchId ? 1 : 0, 
    ].reduce((sum, val) => sum + val, 0);

    onFilterCountChange(count);
  }, [selectedStatuses, selectedGenders, selectedPayments, searchName, searchId, selectedSamples, donationSortDirection]);

    useEffect(() => {
        if (exportCsv) {
            setLoading(true);
            const filters = {
                name: searchName,
                id: searchId,
                status: selectedStatuses,
                gender: selectedGenders,
                payments: selectedPayments,
            };

            DonorService.exportDonorList([filters])
                .then((response) => {
                    if (response.success) {
                        setShowToast(true);
                        setToastMessage(response.message);
                        setToastVariant("success");

                        const downloadUrl = response.download_url;
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        // link.setAttribute('download', 'Donor_export.csv');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        setLoading(false);
                    } else {
                        setShowToast(true);
                        setToastMessage(response.message);
                        setToastVariant("danger");
                        setLoading(false);
                    }
                })
                .catch((error) => {
                    setShowToast(true);
                    setToastMessage("Error exporting Donor list.");
                    setToastVariant("danger");
                    console.error("Error exporting Donor list:", error);
                    setLoading(false);
                });
        }
    }, [exportCsv]);


    useEffect(() => {
        fetchStatuses();
        fetchGenders();
        fetchPayments();
        fetchSampleTypes();
    }, []);

    useEffect(() => {
        fetchDonorList();
    }, [pagination, selectedStatuses, selectedGenders, selectedPayments, searchName, searchId, selectedSamples, donationSortDirection]);
    //   selectedRoles, searchEmail, searchPhone, searchId

    function fetchDonorList() {
        setLoading(true);
        const filters = {
            name: searchName,
            id: searchId,
            status: selectedStatuses,
            gender: selectedGenders,
            ptype: selectedPayments,
            samples: selectedSamples,
        };

        const params = {
            limit: pagination.limit,
            offset: pagination.offset,
            filters: [filters],
            // sort: [{ donation: donationSortDirection }],
            sort: [{ total_donations: donationSortDirection }],
        };

        DonorService.getDonorList(params)
            .then((response) => {
                setDonorList(response.data.list);
                setTotalDonor(response.data.total)
                setLoading(false);
            })
            .catch((error) => {
                console.error("Failed to fetch donor list", error);
                setLoading(false);
            });


    }

    function fetchStatuses() {
        AdminService.getAdminListStatusTypes()
            .then((statusTypes) => {
                setStatuses(statusTypes);
            })
            .catch((error) => {
                console.error("Failed to fetch status types", error);
            });
    }
    async function fetchSampleTypes() {
        AdminService.getSampleTypes()
            .then((sampleTypes) => {
                setSamples(sampleTypes);
            })
            .catch((error) => {
                console.error("Failed to fetch sample types", error);
            });
    }
    function fetchGenders() {
        AdminService.getAdminListGenderTypes()
            .then((genderTypes) => {
                setGenders(genderTypes);
            })
            .catch((error) => {
                console.error("Failed to fetch gender types", error);
            });
    }
    function fetchPayments() {
        AdminService.getAdminListPaymentsTypes()
            .then((paymentTypes) => {
                setPayments(paymentTypes);
            })
            .catch((error) => {
                console.error("Failed to fetch payments types", error);
            });
    }
    const handleStatusChange = (status) => {
        if (selectedStatuses.includes(status)) {
            setSelectedStatuses(selectedStatuses.filter((s) => s !== status));
        } else {


            setSelectedStatuses([...selectedStatuses, status]);
        }
        setPagination({ ...pagination, page: 1, offset: 0 });
    };

    const handleGenderChange = (gender) => {
        if (selectedGenders.includes(gender)) {
            setSelectedGenders(selectedGenders.filter((g) => g !== gender));
        } else {
            setSelectedGenders([...selectedGenders, gender]);
        }
        setPagination({ ...pagination, page: 1, offset: 0 });
    };

    const handlePaymentChange = (payment) => {
        if (selectedPayments.includes(payment)) {
            setSelectedPayment(selectedPayments.filter((g) => g !== payment));
        } else {
            setSelectedPayment([...selectedPayments, payment]);
        }
        setPagination({ ...pagination, page: 1, offset: 0 });
    };
    
    const handleSampleChange = (sample) => {
        if (selectedSamples.includes(sample)) {
            setSelectedSamples(selectedSamples.filter((s) => s !== sample));
        } else {
            setSelectedSamples([...selectedSamples, sample]);
        }
        setPagination({ ...pagination, page: 1, offset: 0 });
    };

    function handleSortDonations(direction) {
        setDonationSortDirection(direction);
        setPagination({ ...pagination, page: 1, offset: 0 });
    }


    const handleChangeStatus = async (admin, status) => {
        setLoading(true);
        const newStatus = admin.active ? 0 : 1; // Determine the new status
        try {
            const response = await AdminService.changeUserStatus(admin.id, newStatus); // Pass the user ID and new status

            if (response.success == true) {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('success');
                fetchDonorList();
                setLoading(false); 
            }
            else {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');
                setLoading(false);

            }
        } catch (error) {
            setToastMessage("Failed to change user status");
            setShowToast(true);
            setToastVariant('error');
            console.error("Failed to change user status:", error);
            setLoading(false); 
        }
    };

    const handleDeleteUser = async (userId) => {
        try {

            const response = await AdminService.deleteAdminUser(userId);

            if (response.success == true) {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('success');
                console.log("User deleted successfully:", response);
                fetchDonorList();
            }
            else {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');
            }
        } catch (error) {
            console.error("Failed to delete user:", error);
        }
    };

    const handleRowsPerPageChange = (newRowsPerPage) => {

        if (newRowsPerPage === 'Show All') {
            setRowsPerPage(totalDonors);
            setPagination({ limit: totalDonors, offset: 0, page: 1 });
        } else {
            setRowsPerPage(Number(newRowsPerPage));
            setPagination({ limit: Number(newRowsPerPage), offset: 0, page: 1 });
        }
    };

    const totalFiltered = DonorList.length;  //ex 10 
    const totalPages = Math.ceil(totalDonors / rowsPerPage); // 10 / 2rpp  then  5 pages

    const handleNextPage = () => {
        setPagination({ ...pagination, offset: pagination.page * rowsPerPage, page: pagination.page + 1 });
    };

    const handlePreviousPage = () => {
        setPagination({ ...pagination, offset: (pagination.page - 2) * rowsPerPage, page: pagination.page - 1 });
    };


    const confirmSelectSpecificDonor = async (payload) => {
        setLoading(true);
        try {
            const result = await SampleRequestService.inviteSpecificDonor(payload);
            if (result.success == true) { 
                setLoading(false);
                setToastMessage(result.message);
                setShowToast(true);
                setToastVariant('success');
            }
            else {
                // Check if the result.message is an object
                let formattedMessage = '';
                if (typeof result.message === 'object' && result.message !== null) {
                    // Convert object to a readable string
                    formattedMessage = Object.keys(result.message)
                        .map((key) => `${key}: ${result.message[key].join(', ')}`)
                        .join(' | ');
                } else {
                    // Use result.message directly if it's not an object
                    formattedMessage = result.message || 'An error occurred.';
                }

                setLoading(false);
                setToastMessage(formattedMessage);
                // setToastMessage(result.message);
                setShowToast(true);
                setToastVariant('error');
            }
        } catch (error) { 
            console.error("Failed to notify requestor:", error);
            setLoading(false);
            setToastMessage(error.message);
            setShowToast(true);
            setToastVariant('error');
        }
    
    }; 

    const isMobile = useMediaQuery({ maxWidth: 768 });
    return (
        <div className="">
            <Loader loading={loading}/>

            {isMobile ? (
                 

                <div className="admin-card-list mt-3">
                    {DonorList.length > 0 ? 
                        <div  className="row"> 
                        {
                        DonorList.map((Donor, index) => (
                            <div className="col-sm-12 col-md-6 mb-3" key={Donor.id}>
                                <DonorTableRow
                                    key={Donor.id}
                                    donor={Donor}
                                    handleChangeStatus={handleChangeStatus}
                                    handleDeleteUser={handleDeleteUser}
                                    fetchDonorList={fetchDonorList}
                                    sampleTypes={samples}
                                />
                            </div>
                        ))}</div> : (
                            <NoListDataAvailable type="donor" />
                        )}     
                </div>
              
            ) :(<>

            <div className="el-table-container el-board-table table-x-scroll">
                <Table hover className="table table-striped">
                    <thead>
                        <tr>
                            <th>
                                {/* Job search */}
                                <SearchInput
                                    label="Donor #"
                                    value={searchId}
                                    setValue={setSearchId}
                                    isVisible={isSearchIdInputVisible}
                                    setVisible={setSearchIdInputVisible}
                                />
                            </th>
                            <th>
                                <SearchInput
                                    label="Donor Name"
                                    value={searchName}
                                    setValue={setSearchName}
                                    isVisible={isSearchInputVisible}
                                    setVisible={setSearchInputVisible}
                                />
                            </th>
                            <th>
                                <AdminStatusDropdown
                                    statuses={statuses}
                                    selectedStatuses={selectedStatuses}
                                    handleStatusChange={handleStatusChange}
                                    setSelectedStatuses={setSelectedStatuses}
                                    label = "Status"
                                />
                            </th>
                            <th>
                                <BiologicalSexDropdown
                                    genders={genders}
                                    selectedGenders={selectedGenders}
                                    handleGenderChange={handleGenderChange}
                                    setSelectedGenders={setSelectedGenders} />
                            </th>
                            <th>
                                <SampleTypeDropdown
                                    samples={samples}
                                    selectedSamples={selectedSamples}
                                    handleSampleChange={handleSampleChange}
                                    setSelectedSamples={setSelectedSamples} />
                            </th>
                            <th>
                                <NumberOfDonationSort handleSortDonations={handleSortDonations} sortDirection={donationSortDirection} />
                            </th>
                            <th>
                                <PaymentTypeDropdown
                                    payments={payments}
                                    selectedPayments={selectedPayments}
                                    handlePaymentChange={handlePaymentChange}
                                    setSelectedPayment={setSelectedPayment} />
                            </th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {DonorList.length > 0 ? (DonorList.map((Donor, index) => (
                                <DonorTableRow
                                    key={Donor.id}
                                    donor={Donor}
                                    handleChangeStatus={handleChangeStatus}
                                    handleDeleteUser={handleDeleteUser}
                                    fetchDonorList={fetchDonorList}
                                    sampleTypes={samples}
                                    confirmSelectSpecificDonor={confirmSelectSpecificDonor}
                                />
                            ))) : (
                                <NoListDataAvailable type="donor" />
                            )}
                    </tbody>
                </Table>
            </div>

            </>
         )}
            <TablePagination
                rowsPerPage={rowsPerPage}
                handleRowsPerPageChange={handleRowsPerPageChange}
                pagination={pagination}
                totalPages={totalPages}
                handlePreviousPage={handlePreviousPage}
                handleNextPage={handleNextPage}
                totalUsers={totalDonors}
            />
            <Toaster
                show={showToast}
                message={toastMessage}
                variant={toastVariant}
                onClose={() => setShowToast(false)}
            />
        </div>
    );
}
export default DonorListTable;
